
	/**
	 * @description
	 *  Modelo del detalle de una selección de regalo en un pedido, para
	 *	frontend.
	 *
	 * @see gigot-backend/Services/OrderService.cs
	 */

export class OrderGiftChoiceDetail {

	public productCode: string;
	public productImagePath: string;
	public productName: string;
	public quantityRequested: number;

	/**
	 * @description
	 *	Construye un detalle de selección de regalo con una semántica vacía.
	 *	Nótese que no es lo mismo que construir una selección con valores por
	 *	defecto. Las reglas generales de construcción son:
	 *
	 *      - Campos 'array' se definen como [].
	 *      - Campos 'boolean' se definen como 'false'.
	 *      - Campos 'Date' se definen como 'undefined'.
	 *      - Campos 'enum' se definen como 'undefined'.
	 *      - Campos 'number' se definen como 'undefined'.
	 *      - Campos 'string' se definen como '' (cadena vacía).
	 *      - Campos 'object' se definen llamando a su propio método #empty().
	 *      - Campos de la superclase se definen al igual que campos 'object'.
	 *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
	 *
	 * @returns
	 *	Un detalle de selección de regalo vacío.
	 */
	public static empty(): OrderGiftChoiceDetail {
		const orderGiftChoiceDetail: OrderGiftChoiceDetail = new OrderGiftChoiceDetail();
		orderGiftChoiceDetail.productCode = "";
		orderGiftChoiceDetail.productImagePath = "";
		orderGiftChoiceDetail.productName = "";
		orderGiftChoiceDetail.quantityRequested = undefined;
		return orderGiftChoiceDetail;
	}

	/**
	 * @description
	 *  Método de reificación de un modelo compatible anémico. Esto permite
	 *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
	 *  valor de sus propiedades se mantiene.
	 *
	 * @param anemicOrderGiftChoiceDetail
	 *  El modelo anémico a reificar.
	 *
	 * @returns
	 *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
	 *  profundidad desde el modelo anémico.
	 */
	public static from(anemicOrderGiftChoiceDetail: OrderGiftChoiceDetail): OrderGiftChoiceDetail {
		if (!anemicOrderGiftChoiceDetail) return undefined;
		const orderGiftChoiceDetail: OrderGiftChoiceDetail = OrderGiftChoiceDetail.empty();
		orderGiftChoiceDetail.productCode = anemicOrderGiftChoiceDetail.productCode;
		orderGiftChoiceDetail.productImagePath = anemicOrderGiftChoiceDetail.productImagePath;
		orderGiftChoiceDetail.productName = anemicOrderGiftChoiceDetail.productName;
		orderGiftChoiceDetail.quantityRequested = anemicOrderGiftChoiceDetail.quantityRequested;
		return orderGiftChoiceDetail;
	}
}
